import { PRECALCULATED_SHAPE } from 'constants/actionTypes';

const initialState = null;

export default (state = initialState, action) => {
  switch (action.type) {
    case PRECALCULATED_SHAPE:
      return action.shapeName || initialState;
    default:
      return state;
  }
};
